<template>
  <div>
    <el-header class="document-center-top-header-base">
      <span class="info">正元签电子合同-帮助中心 </span>
      <el-button
          class="goSign-button"
          @click="openSignHome"
          style="">
          返回工作台
      </el-button>
    </el-header>

    <el-container>
      <el-aside style="overflow-y: hidden" class="document-center-left-menu-aside">
        <el-scrollbar class="document-center-left-menu-scrollbar" >
          <el-menu class="el-menu-vertical-demo"
                   width="100%"
                   v-if="leftMenu.length>0"
                   ref="docCenterLeftMenu" :default-active="currentColumnId" text-color="#4E5969" :unique-opened="true">
            <document-center-left class="document-center-left-menu" ref="DocumentCenterLeft" :navMenu="leftMenu"/>
          </el-menu>
        </el-scrollbar>
      </el-aside>
      <el-main class="document-center-body-main" width="100%">
<!--        <div class="menuStatusUpdateBut" v-show="leftMenuStatus=='open'" @click="MenuUpdate(leftMenuStatus)" >{{updateStatusClose}}</div>-->
<!--        <div class="menuStatusUpdateBut" v-show="leftMenuStatus=='close'" @click="MenuUpdate(leftMenuStatus)" >{{updateStatusOpen}}</div>-->
        <document-center-body class="document-center-body" ref="DocumentCenterBody" @changeCurrentColumnId="changeCurrentColumnId"></document-center-body>
      </el-main>
    </el-container>
  </div>
</template>

<script>

import DocumentCenterLeft from "./module/document-center-left.vue";
import DocumentCenterBody from "./module/document-center-body.vue";

import {
  docCenterMenuList
} from "@/api/doccenter/doccenter.js";
import { Bus } from "@/views/document-center/js/bus";

export default {

  name: "document-center",

  components: {
    DocumentCenterLeft,
    DocumentCenterBody,
  },

  data() {
    return {
      leftMenu: [],
      leftMenuWidth: "35",
      leftMenuWidthOpen: "35",
      leftMenuWidthClose: "0",
      leftMenuStatus: "open",
      updateStatusOpen:">",
      updateStatusClose:"<",
      currentColumnId:"",
      logoSrc: ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) + "pc/logo.png",
    }
  },

  created() {
    this.docCenterMenuListInit();
  },

  mounted() {

  },

  methods: {
    changeCurrentColumnId(columnId){
      this.currentColumnId = columnId;
    },
    docCenterMenuListInit() {
      docCenterMenuList().then(res => {
        if (res.data.menuList != null) {
          this.leftMenu = res.data.menuList
        }
        this.initBodyAndLeftMenus();
      })
    },
    initBodyAndLeftMenus(){
      const that = this
      const columnIdExist = this.$route.query.columnId;
      if (columnIdExist != "" && columnIdExist != null && columnIdExist != undefined){
        this.currentColumnId = columnIdExist;
        Bus.$emit('docCenterCmsGetByColumnId',columnIdExist)
        // this.$router.push({ query: {} });
      } else {
        if (that.leftMenu != null && that.leftMenu.length > 0) {
          Bus.$emit('docCenterCmsGetByColumnId',that.leftMenu[0].columnId)
        }
      }
    },
    openSignHome(){
      const url = ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_CONTRACT_URL) ? GLOBAL_CONFIG.APP_CONTRACT_URL : GLOBAL_CONFIG.APP_CONTRACT_URL)
      window.open(url,"_blank")
    },
    MenuUpdate(leftMenuStatus){
      if (leftMenuStatus == "open"){
        this.leftMenuWidth = this.leftMenuWidthClose
        this.leftMenuStatus = "close"
      } else {
        this.leftMenuWidth = this.leftMenuWidthOpen
        this.leftMenuStatus = "open"
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './css/document-cener.scss';
  .el-aside::-webkit-scrollbar {
    display: none;
  }
</style>

